__webpack_require__.p = "https://cdn.suredoc.cn/suredoc-medical-admin-static/_next/";